'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _base = require('../_base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //import React from 'react';
//import ReactQuill from 'react-quill';


//import '../../../../../../node_modules/react-quill/dist/quill.snow.css';
// https://www.npmjs.com/package/react-quill

var GeckoFieldRichtext = function (_GeckoFieldBase) {
	_inherits(GeckoFieldRichtext, _GeckoFieldBase);

	function GeckoFieldRichtext() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, GeckoFieldRichtext);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GeckoFieldRichtext.__proto__ || Object.getPrototypeOf(GeckoFieldRichtext)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (value) {
			return _this.props.handler.bind(_this, _this.field().key, _this.prepareValue(value))();
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	//This has to work differetnly from other fields


	_createClass(GeckoFieldRichtext, [{
		key: 'render',
		value: function render() {
			return null;
			// return (
			// 	<ReactQuill 
			// 		value={this.value()}
			// 		onChange={this.handleChange.bind(this)}
			// 		readOnly={this.isDisabled()}
			// 		placeholder={this.config().placeholder} />
			// );
		}
	}]);

	return GeckoFieldRichtext;
}(_base2.default);

exports.default = GeckoFieldRichtext;